import * as React from "react";
import { cn } from "../lib/cn";

// Cards never get a shadow; 1px border.default and radius.lg carry the structure (P2).
export function Card({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="card" className={cn("rounded-lg border border-line bg-card text-fg-body", className)} {...props} />;
}

/** A titled block of a settings-style page: a bordered card with the feature padding, equal height in its row. */
export function Panel({ className, ...props }: React.ComponentProps<"section">) {
  return (
    <section
      data-slot="panel"
      className={cn("min-w-0 rounded-lg border border-line bg-card p-[var(--nd-card-padding-feature)] text-fg-body", className)}
      {...props}
    />
  );
}

export function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="skeleton" aria-hidden className={cn("nd-skeleton", className)} {...props} />;
}

export function Separator({ className, vertical = false }: { className?: string; vertical?: boolean }) {
  return (
    <div
      role="separator"
      aria-orientation={vertical ? "vertical" : "horizontal"}
      className={cn(vertical ? "h-full w-px bg-line-subtle" : "h-px w-full bg-line-subtle", className)}
    />
  );
}

export function Kbd({ className, ...props }: React.ComponentProps<"kbd">) {
  return (
    <kbd
      className={cn(
        "inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-sm border border-line px-1 font-mono text-[11px] text-fg-muted",
        className,
      )}
      {...props}
    />
  );
}
